var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-checkbox",
    class: {
      'filter-checkbox_white': _vm.theme === 'white'
    }
  }, [_c('FilterGroupWrapper', {
    attrs: {
      "name": _vm.name,
      "active-count": _vm.activeCount,
      "toggle": _vm.innerToggle
    }
  }, [_vm.list.length > 10 ? _c('div', {
    staticClass: "filter-checkbox__search-wrap"
  }, [_c('InputText', {
    staticClass: "filter-checkbox__search-input",
    attrs: {
      "placeholder": "Я ищу..."
    },
    model: {
      value: _vm.query,
      callback: function ($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "filter-checkbox__search-clear",
    on: {
      "click": function ($event) {
        _vm.query = '';
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.innerList.length,
      expression: "innerList.length"
    }],
    staticClass: "filter-checkbox__list",
    class: [{
      'filter-checkbox__list_scroll': _vm.list.length > 7
    }],
    attrs: {
      "name": "flip-list",
      "tag": "div"
    }
  }, _vm._l(_vm.innerList, function (el) {
    return _c('div', {
      key: el.property,
      staticClass: "filter-checkbox__item"
    }, [_c('Checkbox', {
      staticClass: "filter-checkbox__checkbox",
      attrs: {
        "checked": !!_vm.value[el.property],
        "name": el.name,
        "data-e2e": "catalog-filter-checkbox"
      },
      on: {
        "change": function ($event) {
          return _vm.change({
            property: el.property,
            name: el.name,
            value: $event ? el.value : null
          });
        }
      }
    }, [_c('div', {
      staticClass: "filter-checkbox__text"
    }, [_c('div', {
      staticClass: "filter-checkbox__text-name"
    }, [_vm._v("\n              " + _vm._s(el.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "filter-checkbox__text-count"
    }, [_vm._v("\n              (" + _vm._s(el.count) + ")\n            ")])])])], 1);
  }), 0), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.innerList.length === 0,
      expression: "innerList.length === 0"
    }],
    staticClass: "filter-checkbox__search-empty"
  }, [_vm._v("\n      Ничего не найдено\n    ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }